import { pipelineId, tagId } from '../fixture-ids';

const pipelineTagParentRefs = [
  { key: 'pipelineId', entity: 'pipeline' },
  { key: 'tagId', entity: 'tag' },
];

// Legacy rows predate tagId, so tagLabel is their only handle to the tag. Matching on it downgrades
// the row to keyValue and flags it unattributed.
const pipelineTagParentNameKeys = [{ key: 'tagLabel', entity: 'tag' }];

export const pipelineTagEntries = {
  PIPELINE_TAG_ADDED_TO_PIPELINE: {
    entity: 'pipelineTag',
    identity: 'record',
    compositeIdKeys: ['pipelineId', 'tagId'],
    renderMode: 'diff',
    createsRecord: true,
    parentRefs: pipelineTagParentRefs,
    parentNameKeys: pipelineTagParentNameKeys,
    foreignDisplayKeys: ['tagLabel'],
  },
  PIPELINE_TAG_REMOVED_FROM_PIPELINE: {
    entity: 'pipelineTag',
    identity: 'record',
    compositeIdKeys: ['pipelineId', 'tagId'],
    renderMode: 'diff',
    createsRecord: false,
    parentRefs: pipelineTagParentRefs,
    parentNameKeys: pipelineTagParentNameKeys,
    foreignDisplayKeys: ['tagLabel'],
  },
};

const pipelineTagDebugData = {
  pipelineId,
  tagId,
  tagLabel: 'production',
};

export const pipelineTagFixtures = {
  PIPELINE_TAG_ADDED_TO_PIPELINE: {
    action: 'PIPELINE_TAG_ADDED_TO_PIPELINE',
    debugData: { ...pipelineTagDebugData },
  },
  PIPELINE_TAG_REMOVED_FROM_PIPELINE: {
    action: 'PIPELINE_TAG_REMOVED_FROM_PIPELINE',
    debugData: { ...pipelineTagDebugData },
  },
  // The LEGACY shape ({pipelineId, tagLabel}, no tagId) fed through the CURRENT core entry above:
  // no legacy alternate is declared for this shape, so its fixture lives here. compositeIdKeys
  // cannot resolve (tagId absent) -> resolveRow's identity-unresolved fallback fires ->
  // parentNameKeys matches on tagLabel -> renderMode downgrades to 'keyValue', unattributed: true.
  PIPELINE_TAG_ADDED_TO_PIPELINE_LEGACY_SHAPED: {
    action: 'PIPELINE_TAG_ADDED_TO_PIPELINE',
    debugData: { pipelineId, tagLabel: 'production' },
  },
};
